export default __webpack_public_path__ + "static/media/service-thumb-stamped-concrete.d2c1b34d.jpg";